var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActionAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33331 7.3335V4.66683H8.66665V7.3335H11.3333V8.66683H8.66665V11.3335H7.33331V8.66683H4.66665V7.3335H7.33331ZM7.99998 14.6668C4.31798 14.6668 1.33331 11.6822 1.33331 8.00016C1.33331 4.31816 4.31798 1.3335 7.99998 1.3335C11.682 1.3335 14.6666 4.31816 14.6666 8.00016C14.6666 11.6822 11.682 14.6668 7.99998 14.6668ZM7.99998 13.3335C9.41447 13.3335 10.771 12.7716 11.7712 11.7714C12.7714 10.7712 13.3333 9.41465 13.3333 8.00016C13.3333 6.58567 12.7714 5.22912 11.7712 4.22893C10.771 3.22873 9.41447 2.66683 7.99998 2.66683C6.58549 2.66683 5.22894 3.22873 4.22874 4.22893C3.22855 5.22912 2.66665 6.58567 2.66665 8.00016C2.66665 9.41465 3.22855 10.7712 4.22874 11.7714C5.22894 12.7716 6.58549 13.3335 7.99998 13.3335Z",
    fill: "#484B54"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionAdd);
export default __webpack_public_path__ + "static/media/action-add.45b7cdb302a8f7f4b8d27f7aa028b63b.svg";
export { ForwardRef as ReactComponent };